import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from 'styled-components';
import React from 'react';
import Text from '../Text';
import { File, WithIconWrapper } from '../Input';
import { useThemeDefaults } from '../utils';
export var InputError = function InputError(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    textStyle: "bodyXsRegular",
    color: "error",
    mt: "7px"
  }, props));
};
export var Count = function Count(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    textAlign: "right",
    textStyle: "bodyRegular",
    color: "labelPlaceholder",
    sa: "spacer5"
  }, props));
};
var BaseLabel = styled(Text).withConfig({
  displayName: "Form__BaseLabel",
  componentId: "sc-xdycf6-0"
})(["", ",", "{margin-top:6px;}"], WithIconWrapper, File);
export var Label = useThemeDefaults(function (props) {
  return {
    as: 'label',
    display: 'block',
    color: 'label',
    textStyle: props.inline ? ['bodyViewSRegular', 'bodyRegular'] : ['bodyViewSMedium', 'bodyMedium']
  };
}, BaseLabel);
Label.propTypes = _objectSpread({}, Text.propTypes);